import type { Absence, Planned } from "../lib/api";
import { nextInWeek, relative, human, weekStrip } from "../lib/calendar";
import { haptic } from "../lib/telegram";

/**
 * Неделя полосой на главной — и вход в календарь.
 *
 * Раньше календарь открывался маленькой ссылкой в углу, набранной как
 * служебная метка: «его далеко не все заметят» (19-home-and-bot-cards.md §2).
 * Полоса заметна, занимает ширину экрана и по дороге отвечает на вопрос, ради
 * которого туда обычно и идут: что у меня на неделе.
 */
export default function WeekStrip({
  today,
  planned,
  absences = [],
  onOpen,
}: {
  today: string;
  planned: Planned[];
  absences?: Absence[];
  onOpen: () => void;
}) {
  const cells = weekStrip(today, planned, absences);
  const next = nextInWeek(planned, today);

  return (
    <button
      className="card week"
      onClick={() => {
        haptic();
        onOpen();
      }}
    >
      <span className="week__head">
        <span className="card__title" style={{ margin: 0 }}>Неделя</span>
        <span className="week__more">календарь →</span>
      </span>

      <span className="week__days">
        {cells.map((cell) => (
          <span
            key={cell.date}
            className={`week__day${cell.today ? " week__day--today" : ""}${
              cell.away ? " week__day--away" : ""
            }`}
          >
            <span className="week__label">{cell.label}</span>
            <span className="week__num">{cell.day}</span>
            <span className="week__marks">
              {cell.status && <i className={`cal__mark cal__mark--${cell.status}`} />}
            </span>
          </span>
        ))}
      </span>

      <span className="lead week__next">
        {next
          ? `${relative(next.date, today) ?? human(next.date, today)} — ${next.day_name}, ${next.block_name}`
          : "Расписания нет — составьте, и приложение будет звать само"}
      </span>
    </button>
  );
}
